// ================================================================
// Projects API — list-e project-ha (org-scoped)
// olgu-ye apiRequest() mesl-e core/whatsapp.js va core/email.js
// ================================================================
import { apiRequest } from './apiClient.js';

const base = '/api/projects';

// phaseB-api: hameye project-ha ba filter-ha (search, archived, status, assignedUserId, from, to)
export function listProjects(opts) {
  const o = opts || {};
  const params = new URLSearchParams();
  if (o.search && o.search.trim()) params.set('search', o.search.trim());
  if (o.archived) params.set('archived', 'true');
  if (o.status) params.set('status', o.status);
  if (o.assignedUserId) params.set('assignedUserId', o.assignedUserId);
  if (o.from) params.set('from', o.from);
  if (o.to) params.set('to', o.to);
  const q = params.toString();
  return apiRequest(base + (q ? '?' + q : ''));
}

// project-ha-ye yek moshtari
// get-project-core: yek project-e kamel ba jozviyat
export function getProject(id) {
  return apiRequest('/api/projects/' + encodeURIComponent(id));
}

export function listProjectsByContact(contactId) {
  return apiRequest(base + '/by-contact/' + encodeURIComponent(contactId));
}

// sakht-e project-e jadid
export function createProject(data) {
  return apiRequest(base, { method: 'POST', body: JSON.stringify(data) });
}

// virayesh
export function updateProject(id, patch) {
  return apiRequest(base + '/' + encodeURIComponent(id), { method: 'PATCH', body: JSON.stringify(patch) });
}

// archive / un-archive
export function archiveProject(id, archived = true) {
  return apiRequest(base + '/' + encodeURIComponent(id) + '/archive', { method: 'POST', body: JSON.stringify({ archived }) });
}

// hazf (soft-delete)
export function deleteProject(id) {
  return apiRequest(base + '/' + encodeURIComponent(id), { method: 'DELETE' });
}
